<template>
  <div class="order-signing-audit">
    <OrderFilterAudit
      :type.sync="type"
      @updateFilter="updateFilter"
    />
    <el-tabs v-model="activeName">
      <el-tab-pane label="托乐乐及小班课体验" name="tuolele">
        <OrderSignAuditDetail
          :type.sync="type"
          :search.sync="search"
        />
      </el-tab-pane>
      <el-tab-pane label="小班课续费及新签订单" name="second">
        <OrderSmallClassSignAuditDetail
          :type.sync="type"
          :search.sync="search"
        />
      </el-tab-pane>

    </el-tabs>

  </div>
</template>
<script>
import OrderFilterAudit from '@/components/order/OrderFilterAudit.vue'
import OrderSignAuditDetail from '@/components/order/OrderSignAuditDetail.vue'
import OrderSmallClassSignAuditDetail from '@/components/order/OrderSmallClassSignAuditDetail.vue'
export default {
  name: 'OrderSignAuditDetailAll',
  components: {
    OrderFilterAudit,
    OrderSignAuditDetail,
    OrderSmallClassSignAuditDetail
  },
  data() {
    return {
      type: 'signingAudit',
      search: {
        p: 1,
        limit: 10,
        shop_id: '0',
        payment: '',
        status: '1',
        give_type: '0'
      },
      activeName: 'tuolele'
    }
  },
  mounted() {},
  methods: {
    updateFilter(val) {
      this.search = val
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__item {
  padding-left:20px!important ;
  padding-right:20px!important ;
}
</style>
